import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@ibsys/kit';
import { formatHHMMSS, formatInt, formatMMSS } from './utils';

type Props = {
  totalCalls: number;
  avgDuration: number | null;
  totalDuration: number;
};

/**
 * Верхний ряд KPI-метрик: всего звонков, среднее время разговора,
 * общая длительность за выбранный период.
 */
export const KpiRow: FC<Props> = ({ totalCalls, avgDuration, totalDuration }) => {
  const { t } = useTranslation('renessansDashboard');

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
      <Card>
        <CardContent className="p-4">
          <div className="text-xs text-muted-foreground mb-1">{t('kpi.totalCalls')}</div>
          <div className="font-bold text-2xl">{formatInt(totalCalls)}</div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <div className="text-xs text-muted-foreground mb-1">{t('kpi.avgDuration')}</div>
          <div className="font-bold text-2xl">{formatMMSS(avgDuration)}</div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <div className="text-xs text-muted-foreground mb-1">{t('kpi.totalDuration')}</div>
          <div className="font-bold text-2xl">{formatHHMMSS(totalDuration)}</div>
        </CardContent>
      </Card>
    </div>
  );
};
